import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "vr",
    title: "Virtual Reality",
    icon: require("./content-icon.svg"),
    category: "multimedia",
    Viewer,
    Editor,
    Preview: Viewer
}